import script from "./MainNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainNav.vue?vue&type=script&setup=true&lang=ts"

import "./MainNav.vue?vue&type=style&index=0&id=0f321b7a&lang=scss"

const __exports__ = script;

export default __exports__